<template>
  <div id="app" class="vuediv">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue